/**
 * @generated SignedSource<<a3dd60f2bc5796f47ec6727da194fc33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAccountsScreenDeleteMutation$variables = {
  id: string;
};
export type ServiceAccountsScreenDeleteMutation$data = {
  readonly store: {
    readonly serviceAccount: {
      readonly delete: boolean;
    } | null;
  };
};
export type ServiceAccountsScreenDeleteMutation = {
  response: ServiceAccountsScreenDeleteMutation$data;
  variables: ServiceAccountsScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "ServiceAccountMutations",
        "kind": "LinkedField",
        "name": "serviceAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "delete",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceAccountsScreenDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceAccountsScreenDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4bd87941e980cd523323cb581a041ee1",
    "id": null,
    "metadata": {},
    "name": "ServiceAccountsScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceAccountsScreenDeleteMutation(\n  $id: ID!\n) {\n  store {\n    serviceAccount(id: $id) {\n      delete\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e9ffecd32e3dc3cbdc234f639cb88a7";

export default node;
